import { View } from 'foundations-components/components/View';
import { useCardContextValue } from '../state/CardContext';
import { Flex } from 'foundations-components/components/Flex';
import { useCallback } from 'react';
import { Box } from 'foundations-components/transitional/components/Box';
import DynamicWidthPropertyLabel from './DynamicWidthPropertyLabel';
import ClickablePropertyInputWrapper from './ClickablePropertyInputWrapper';
import { useCardRenderMarkers } from 'crm-cards-sdk/hooks/useCardRenderMarkers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const PropertiesList = ({
  isEditable = true
}) => {
  const {
    SuccessMarker
  } = useCardRenderMarkers();
  const {
    propertyNames,
    asyncData: {
      propertyDefinitionsResult
    }
  } = useCardContextValue();
  const getPropertyLabel = useCallback(propertyName => {
    var _propertyDefinitionsR;
    const propertyDefinition = (_propertyDefinitionsR = propertyDefinitionsResult.data) === null || _propertyDefinitionsR === void 0 ? void 0 : _propertyDefinitionsR.get(propertyName);
    if (!propertyDefinition) {
      return propertyName;
    }
    return propertyDefinition === null || propertyDefinition === void 0 ? void 0 : propertyDefinition.property.label;
  }, [propertyDefinitionsResult.data]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "100",
      paddingBlockEnd: "100",
      "data-test-id": "properties-list",
      children: propertyNames.map(name => /*#__PURE__*/_jsxs(Flex, {
        alignSelf: "start",
        children: [/*#__PURE__*/_jsx(Box, {
          overflow: "hidden",
          maxInlineSize: "50%",
          minInlineSize: "30px",
          children: /*#__PURE__*/_jsx(View
          // add transparent bottom border to better align with inputs that also have a bottom border
          , {
            borderBlockEndWidth: "100",
            borderBlockEndStyle: "solid",
            borderBlockEndColor: "fill-transparent-default",
            children: /*#__PURE__*/_jsx(DynamicWidthPropertyLabel, {
              label: getPropertyLabel(name)
            })
          })
        }), /*#__PURE__*/_jsx(Box, {
          flexGrow: "1",
          overflow: "hidden",
          minInlineSize: "30px",
          children: /*#__PURE__*/_jsx(ClickablePropertyInputWrapper, {
            propertyName: name,
            isEditable: isEditable
          }, name)
        })]
      }, name))
    }), /*#__PURE__*/_jsx(SuccessMarker, {})]
  });
};
export default PropertiesList;